import { AccountComponent } from '@app/client/account/account.component';
import { AccountPremiumCanActivateGuard } from '@app/core/guards/account-premium.can-activate.guard';
import { SelectTeamGuard } from '@app/core/guards/base/select-team.guard';
import { CanAccessAdministrationGuard } from '@app/core/guards/can-access-administration.guard';
export const ACCOUNT_ROUTES = [
    {
        path: '',
        component: AccountComponent,
        canActivate: [AccountPremiumCanActivateGuard],
        children: [
            {
                path: 'team/:id',
                loadChildren: () => import('@app/client/account/team/team.module').then(m => m.TeamModule),
                canActivate: [SelectTeamGuard],
            },
            {
                path: 'admin',
                canActivate: [CanAccessAdministrationGuard],
                loadChildren: () => import('@app/client/account/admin/admin.module').then(m => m.AdminModule),
            },
            {
                path: 'profile',
                data: { section: 'PREMIUM_PROFILE_SECTION' },
                loadChildren: () => import('@app/client/account/profile/profile.module').then(m => m.ProfileModule),
            },
        ]
    },
];
